export default class SplashScreen {

    public static remove(): void {
        const root = document.getElementById("root");
        const splash = document.getElementById("ipsUISplashScreen");
        if (!root) {
            return;
        }
        root.style.visibility = "visible";
        if (!splash) {
            return;
        }
        splash.animate({ opacity: 0 }, { duration: 2000 }).onfinish = () => {
            document.getElementById("ipsUISplashScreen")?.remove();
        };
    }

}
